const styles = theme => ({
  field: {
    '& > .MuiInputBase-formControl': {
      border: `1px solid ${theme.palette.primary.borderColor}`,
      borderRadius: '4px',
      padding: '0',
      overflow: 'hidden',
      '&.Mui-focused fieldset': {
        border: '0 !important',
        boxShadow: 'none !important',
      },
      '& fieldset': {
        border: '0 !important',
        boxShadow: 'none !important',
      },
    },

    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-input': {
        height: 'auto',
        padding: '12px !important',
        borderRadius: '0px',
        color: theme.palette.primary.adgmBlack,
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',

        '&::placeholder': {
          color: theme.palette.primary.darkGrey,
          opacity: '1',
        },
      },
    },
  },
  input: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    '&::placeholder': {
      color: theme.palette.secondary.disableLightGray,
    },
  },
  searchBtn: {
    minWidth: 'auto',
    height: 'auto',
    background: '#0088FF',
    padding: '12px',
    borderRadius: '0',
    boxShadow: 'none',

    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  bigSize: {
    padding: '17px',
  },
  coloredBg: {
    background: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.adgmHover,
    },
  },
  large: {
    fontSize: '24px',
  },
});

export default styles;
